import {useState, useEffect} from 'react'
import axios from 'axios'
import { api_url } from '../config'
import {useParams, Link, useLocation} from 'react-router-dom'
import { Container } from 'reactstrap'
import ShareContent from '../components/ShareContent'
import Helmet from 'react-helmet'
import ListPromo from '../components/ListPromo'
import PromoLoading from '../components/PromoLoading'

interface ParamTypes {
  slug: string
}

interface Data {
  acf: {
    berlaku_hingga: string,
    diskon: string
  },
  title: {
    rendered: string
  },
  content: {
    rendered: string
  },
  _embedded: any[string]
}

declare global {
  interface Window {
    dataLayer: any
  }
}

const Promo = () => {
  const {slug} = useParams<ParamTypes>()
  const [data, setData] = useState<Data[]>([{
    acf: {
      berlaku_hingga: '',
      diskon: ''
    },
    title: {
      rendered: ''
    },
    content: {
      rendered: ''
    },
    _embedded: []
  }])

  const [related, setRelated] = useState({
    data: []
  })

  const [showLoader, setShowLoader] = useState(true)

  const location = useLocation()
  useEffect(() => {
    setShowLoader(true)
    axios.get(`${api_url}/wp/v2/posts?slug=${slug}&_embed`)
    .then((response : any) => {
      setData(response.data)
      const categories = response.data[0].categories.join()
      axios.get(`${api_url}/wp/v2/posts?categories=${categories}&per_page=4&orderby=rand&_embed`)
      .then((res : any) => {
        setRelated({
          data: res.data
        })
        setTimeout(() => {
          setShowLoader(false)
        }, 500)
        window.dataLayer.push({
          event: 'pageview',
          page: {
            url: document.location.origin + location.pathname + location.search,
            title: response.data[0].title.rendered.replace('&#8211;', '-')
          }
        });
      })
    })
  }, [slug])

  return (
    <>
      <div className="bg-white">
        <Container className="container-smaller">
          <div className={!showLoader ? 'd-none' : ''}>
            <PromoLoading />
          </div>
          {data && data.map((item: Data, i) => {
            let checkBerlakuDate : any[] = item.acf.berlaku_hingga.split('-')
            return (
              <div key={i} className={`DetailPromo ${showLoader ? 'd-none' : ''}`}>
                <Helmet>
                  <title>{`BCA - ${item.title.rendered.replace('&#8211;', '-')}`}</title>
                </Helmet>
                <div className="mb-5 px-lg-5">
                  <h1 dangerouslySetInnerHTML={{__html: item.title.rendered}} className="promo-title" />
                  <p className="text-grey text-date" dangerouslySetInnerHTML={{__html: `${(checkBerlakuDate.length > 1) ? 'Periode Promosi' : 'Hingga'} ${item.acf.berlaku_hingga}`}}/>
                </div>
                <div className="mb-5 featured-media">
                  {(item._embedded["wp:featuredmedia"] !== undefined) && (
                    <img src={item._embedded["wp:featuredmedia"][0].source_url} className="w-100" alt={item.title.rendered}/>
                  )}
                </div>
                <div className="px-lg-5">
                  <h3>Lokasi Promo</h3>
                  <div className="d-flex mb-4 align-items-center list-location">
                    <i className="a-system-icon is-medium icon-location mr-3"></i>
                    {(item._embedded["wp:term"]) && (
                      item._embedded["wp:term"].map((taxonomy : any) => {
                        return (
                          taxonomy.map((tags : any, i : number) => {
                            return (
                              (tags.taxonomy === 'post_tag') && (
                                <Link to={`/?city=${tags.id}`} key={i} className="mr-3 text-decoration-none">{tags.name}</Link>
                              )
                            )
                          })
                        )
                    }))}
                  </div>
                  <h2 className="font-weight-bold text-blue sub-title mb-5">{item.acf.diskon}</h2>
                  <div dangerouslySetInnerHTML={{__html : item.content.rendered }} className="content-rendered mb-5" />
                  <ShareContent />
                </div>
              </div>
            )
          })}
        </Container>
      </div>
      <div className="RelatedPromo bg-light-blue">
        <Container className="py-5">
          <div className="d-flex justify-content-between">
            <h3>Promo Serupa</h3>
            <Link to="/" className="align-items-center text-decoration-none d-none d-sm-flex"><span className="mr-2">Lihat Promo Lainnya</span> <i className="a-system-icon icon-chevron-next"></i></Link>
          </div>
          <ListPromo {...related} className="mb-4" />
          <div className="d-flex justify-content-center d-sm-none py-5">
            <Link to="/" className="align-items-center text-decoration-none d-flex"><span className="mr-2">Lihat Promo Lainnya</span> <i className="a-system-icon icon-chevron-next"></i></Link>
          </div>
        </Container>
      </div>
    </>
  )
}

export default Promo